import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import moment from "moment";
import "./Date.css";

const styles = (theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    borderRadius: "12px",
    outline: "none",
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
    '@media (max-width: 768px)' : {
      width: 155,
    }
  },
});

function DatePickers({
  classes = {},
  onChange = () => {},
  value = moment().add(1, "days").format("DD-MM-YYYY"),
}) {
  return (
    <form className={classes.container} noValidate>
      <TextField
        id="date"
        label=""
        type="date"
        defaultValue={moment(value, "DD-MM-YYYY").format("YYYY-MM-DD")}
        className={classes.textField}
        InputLabelProps={{
          shrink: true,
        }}
        inputProps={{
          min: moment().format("YYYY-MM-DD"),
          max: moment().add(3, "months").format("YYYY-MM-DD"),
        }}
        onChange={(e) => onChange(moment(e.target.value).format("DD-MM-YYYY"))}
      />
    </form>
  );
}

DatePickers.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DatePickers);
